import React from 'react';

/**
 * Loader element.
 *
 * @returns {JSX.Element}
 * @constructor
 */
function FunnelbackInstanSearchLoadingState() {
    return <div>Loading...</div>;
}

export default FunnelbackInstanSearchLoadingState;
